import { createFileRoute, redirect } from "@tanstack/react-router";

// `/` → `/overzicht`. The _shell guard handles the unauthenticated case.
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/overzicht" });
  },
});
